<script setup lang="ts">
// NOTE: This component should be instantiated only once preferably in the root component
import { useEventListener } from '@vueuse/core';

import { useShareWidgetStore } from '../stores';

const store = useShareWidgetStore();

useEventListener(window, 'inspire:share-closed', () => {
  store.closeModal();
});
</script>

<template>
  <share-component
    v-if="store.isRecipeValid"
    :recipe="store.recipe"
    :hide-share-button="true"
    :show-modal="store.showModal ? true : undefined"
  />
</template>
